import { ApolloProvider } from '@apollo/react-hooks';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';

import { client } from './config/apolloClient';
import MainRouter from './routers/MainRouter';

import './styles/styles.css';
import 'tailwindcss/dist/base.css';

ReactDOM.render(
  <ApolloProvider client={client}>
    <BrowserRouter>
      <MainRouter />
    </BrowserRouter>
  </ApolloProvider>,
  document.getElementById('root'),
);
